/* global FILTER_PRODUCTS_BY_STORE, jQuery, ProductPriceByTags, Shopify */
/* exported ProductCard */

const ProductCard = (() => {
    const getHighlightedLabelText = ({ tags, price, priceHistory, element = null }) => {
        let labelTitle = '';
        const productPriceWithDiscount = price * 100;
        const comparablePrice = ProductPriceByTags.getComparablePrice(priceHistory, productPriceWithDiscount);
        const hasZeroTag = tags.some((tag) => tag.includes('BDT:') && tag.includes('#0'));
        const hasDphDiscoutTag = tags.some((tag) => {
            return tag.includes(Shopify.theme_settings.tag_bad_without_vat) && tag.includes('★');
        });

        if (
            comparablePrice > productPriceWithDiscount &&
            !FILTER_PRODUCTS_BY_STORE &&
            Shopify.theme_settings.show_price_label_by_price_history
        ) {
            const percentage = Math.floor((comparablePrice - productPriceWithDiscount) / comparablePrice * 100);

            const isElectroDiscount = tags.includes(Shopify.translation.col_electro) &&
                percentage >= Shopify.theme_settings.electro_min_percentage_discount;

            const isFurnitureDiscount = tags.includes(Shopify.translation.col_furniture) &&
                percentage >= Shopify.theme_settings.furniture_min_percentage_discount;

            if (hasDphDiscoutTag) {
                labelTitle = Shopify.translation.discount_price_label_without_vat;
            } else if (isElectroDiscount || isFurnitureDiscount) {
                labelTitle = Shopify.translation.discount_price_label_percentage.replace('{percent}', percentage);
            }
        }

        if (!labelTitle.length && hasZeroTag && Shopify.theme_settings.show_price_label_by_zero_tag) {
            labelTitle = Shopify.translation.discount_price_label;
        }

        if (element !== null && labelTitle.length) {
            const elementToHighlight = element instanceof jQuery ? element.get(0) : element;
            if (elementToHighlight && elementToHighlight.childNodes.length && labelTitle) {
                elementToHighlight.classList.add('price-label-highlighted');
                elementToHighlight.dataset.beforeContent = labelTitle;
            }
        }

        return labelTitle;
    };

    const formatJdgmStarsCount = (id, dataJdgm) => {
        let jdgmFormatedCount = '';

        if (dataJdgm && Shopify.theme_settings.enable_shopify_collection_badges) {
            const dataToFormate = dataJdgm.replace(/\|/g, '"');
            const match = dataToFormate.match(/data-number-of-reviews=['"](\d+)['"]/);
            const numberOfReviews = match ? match[1] : '0';

            if (numberOfReviews !== '0') {
                const numberOfReviewsText = '(' + numberOfReviews + ')';
                jdgmFormatedCount = dataToFormate.replace(/([0-9]+) reviews?/, numberOfReviewsText);
            }
        }

        return `<div class="jdgm-widget jdgm-preview-badge" data-id="${id}">${jdgmFormatedCount}</div>`;
    };


    const isDisabledTagAction = (tag, productAvailable) => {
        const disabledProductTagActionIds = Shopify.theme_settings.disabled_product_tag_action_ids;
        let isTagActionDisabled = false;

        if (disabledProductTagActionIds.length) {
            const regex = /\{([^}]+)\}/;
            const matches = tag.match(regex);

            if (matches) {
                const contentInsideBraces = matches[1];
                const disabledProductTagActionIdsArray = disabledProductTagActionIds;

                disabledProductTagActionIdsArray.forEach((item) => {
                    if (item.trim() === contentInsideBraces && !productAvailable) {
                        isTagActionDisabled = true;
                        return;
                    }
                });
            }
        }

        return isTagActionDisabled;
    };

    return { getHighlightedLabelText, formatJdgmStarsCount, isDisabledTagAction };
})();
